import { defineComponent } from "vue";

import "./checkbox.less";

export default defineComponent({
  name: "MCheckbox",
  emits: ["update:modelValue"],
  props: {
    modelValue: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
  },
  setup(props, { slots, emit }) {
    const onChange = (event: Event) => {
      if (props.disabled) return;
      const target = event.target as HTMLInputElement;
      emit("update:modelValue", target.checked);
    };

    const createCheckNode = () => {
      return (
        <div class="feiyu-web-share-checkbox--check">
          <div class="feiyu-web-share-checkbox--check-inner" />
          <input
            checked={props.modelValue}
            disabled={props.disabled}
            type="checkbox"
            onChange={onChange}
          />
        </div>
      );
    };

    const createLabelNode = () => {
      if (!slots.default) return null;
      return <div class="feiyu-web-share-checkbox--text">{slots.default()}</div>;
    };

    return () => (
      <label
        class={[
          "feiyu-web-share-checkbox",
          { "feiyu-web-share-checkbox--checked": props.modelValue },
          { "feiyu-web-share-checkbox--disabled": props.disabled },
        ]}
      >
        {createCheckNode()}
        {createLabelNode()}
      </label>
    );
  },
});
